import { render, staticRenderFns } from "./SfProductCardHorizontal.vue?vue&type=template&id=a4b781a4&scoped=true&"
import script from "./SfProductCardHorizontal.vue?vue&type=script&lang=ts&"
export * from "./SfProductCardHorizontal.vue?vue&type=script&lang=ts&"
import style0 from "./SfProductCardHorizontal.vue?vue&type=style&index=0&id=a4b781a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b781a4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductLabels: require('/usr/src/app/components/storyblok/ProductLabels.vue').default})
